import { render, staticRenderFns } from "./form-draggable-section.vue?vue&type=template&id=6981e5f3&scoped=true"
import script from "./form-draggable-section.vue?vue&type=script&lang=js"
export * from "./form-draggable-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981e5f3",
  null
  
)

export default component.exports